import styled from 'styled-components';

const StyledTextField = styled.div`
	input,
	textarea {
		background: transparent;
		color: #ffffff;
		padding: 16px 14px;
	}

	.MuiFormControl-root {
		width: 100%;
	}

	.MuiOutlinedInput-multiline {
		padding: 0px;
	}

	.MuiOutlinedInput-notchedOutline {
		border-color: #ffffff21;
	}

	.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
		border-color: ${props => props.theme.label.color};
	}

	.MuiFormLabel-root.Mui-focused {
		color: ${props => props.theme.label.color};
	}

	.Mui-focused {
		fieldset {
			border: 1px solid ${props => props.theme.label.color} !important;
		}
	}

	.MuiInputLabel-outlined {
		color: #ffffff;
	}

	.MuiFormLabel-root {
		font-size: 15px;
	}
`;

export default StyledTextField;

export const Error = styled.p`
	margin: 5px 0px 0px 0px;
	color: #ffffffc2;
	text-align: left;
`;
